import { Table } from '@/core/support_gui_components/table/table'
import { TableDataPreparer } from '@/core/support_gui_components/table/table_data_preparer'
import { bindResetButton } from '@/core/input_controls/button/button'
import { getLocalizedMessage, removeTabindex, showMessageAlert } from '@/core/shared'
import { mergeData, mergeDataSLSN } from '@/core/item_assistance/mergeItemData'

export function initItemCopy (context) {
	window.itemStructure = JSON.parse(JSON.stringify(context.$store.getters.getItemStructure))
	window.tableColumns = JSON.parse(JSON.stringify(context.$store.getters.getTableColumn))

	const attributesGroups = JSON.parse(JSON.stringify(context.attributesGroups))

	let contextMenu = {}
	attributesGroups.forEach((group, index) => {
		contextMenu[index + 2] = function (item) { mergeItemData(item, group.attributes, group.title, false, context) }
	})
	contextMenu[attributesGroups.length + 2] = function (item) {
		mergeItemData(item, [], null, true, context)
	}

	window.table = new Table('copyItemsTable', {
		selector: '#table',
		columns: tableColumns,
		dynamicLoading: true,
		contextMenu: '#context-menu',
		sortingSupport: true,
		frozen: 'none'
	},
	{
		contextMenu: {
			1: function (item) {
				window.open('/item-view/' + item.id, '_blank')
			},
			...contextMenu
		}
	},
	function (data) {
		new TableDataPreparer(data, itemStructure)
	})

	table.setDataUrl(window.urlContext + 'items/table-format/load')
	table.setDataIDsUrl(window.urlContext + 'items/ids')
	table.setDataSortUrl(window.urlContext + 'items/sort')
	table.initTable()

	bindResetButton()
	removeTabindex()
}

function mergeItemData (item, attributes, tabName, isAll, context) {
	Swal.fire({
		title: getLocalizedMessage('merge.data'),
		html: tabName ? context.$t('merge.data.item.from') + ' ' + context.$t(tabName) + '?': context.$t('merge.all.data.item') + '?',
		confirmButtonText: context.$t('true'),
		showCancelButton: true,
		cancelButtonText: context.$t('cancel'),
		buttonsStyling: false,
		allowOutsideClick: false,
		allowEnterKey: true,
		focusCancel: true,
		showClass: {
			popup: ''
		},
		hideClass: {
			popup: ''
		},
		customClass: {
			confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
			cancelButton: 'uk-button uk-button-default uk-button-small'
		}
	}).then((result) => {
		if (result.value) {
			const dataItemSource = loadData(item.id)
			const dataItemTo = JSON.parse(JSON.stringify(context.itemData))
			const itemStructure = context.itemStructure
			const langs = context.$store.getters.getLanguage
			let attributeMerge = []
			let dataItemFrom = {}

			function calcAttrMerge (arr, res) {
				arr.forEach(attr => {
					if (attr.type === 'ATTRIBUTE') {
						res.push(attr.title)
					} else {
						calcAttrMerge(attr.attributes, res)
					}
				})
			}

			calcAttrMerge(attributes, attributeMerge)

			if (isAll) {
				dataItemFrom = dataItemSource
			} else {
				attributeMerge.forEach(attr => {
					dataItemFrom[attr] = dataItemSource[attr]
				})
			}

			let resData = mergeData(dataItemTo, dataItemFrom)

			let unsavedData = {}
			mergeDataSLSN(dataItemTo, dataItemFrom, itemStructure, langs, unsavedData, resData)

			context.$set(context, 'itemData', resData)
			context.$store.commit('UPDATE_ITEM_DATA', resData)

			context.tabContentKey += 1

			context.$nextTick(function () {
				editableTradeItem.unsavedDataManager.setUnsavedData(unsavedData)
			})

			showMessageAlert(getLocalizedMessage('data.merging.success'), 'success')
			Swal.close()
		}
	})
}

function loadData (id) {
	let data = {}
	$.ajax({
		url: window.urlContext + 'items/' + id + '/load',
		type: 'GET',
		dataType: 'json',
		async: false,
		context: this,
		success: function (sourceData) {
			data = sourceData
		}
	})
	return data
}
